import React from "react";
import { IForm } from "../models/Form.model";
import { InputText } from "primereact/inputtext";

interface SharedInputTextProps {
  item: IForm;
  handleFormData: any;
}

export default function SharedInputText({
  item,
  handleFormData,
}: SharedInputTextProps) {
  return (
    <div className="form-group">
      <label>{item.label}</label>
      <InputText
        value={item.value}
        placeholder={item.placeholder || ""}
        onChange={(e) => handleFormData(e.target.value)}
        disabled={item.isDisabled}
      />
    </div>
  );
}
